import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Palette } from "../AppConfig";
import { toNumber } from "../components/Common";
import TextField from "@material-ui/core/TextField";
import BSL_ControlContainer from "./BSL_ControlContainer";
import { Tooltip } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    input: {
        padding: "2px",
        marginTop: theme.brand.FIELDERS ? "0px" : "2px",
        font: theme.brand.FIELDERS
            ? "200 14px " + theme.typography.fontFamily
            : "200 13px " + theme.typography.fontFamily,
        padding: "10px 8px",
        minWidth: "24px",
    },
    input_tight: {
        padding: "4px 0px 4px 8px !important",
    },
    input_extra_tight: {
        padding: "4px 0px 4px 8px !important",
    },
    textField: {
        borderRadius: "0px",
        background: "white",
        border: theme.brand.FIELDERS ? "1px solid " + Palette.FieldersBlue : "1px solid " + Palette.Lysaght.DarkBlue,
        "&:before": {
            border: "none",
        },
    },
    notchedOutline: {
        "&:focus": {
            borderWidth: "1px",
            borderColor: theme.brand.FIELDERS
                ? Palette.FieldersBlue + " !important"
                : Palette.Lysaght.LightBlue + " !important",
        },
    },
    disabled: {
        backgroundColor: Palette.Control.LightGrey,
    },
    endAdornment: {
        paddingLeft: "1px",
        paddingRight: "6px",
        font: theme.brand.FIELDERS
            ? "200 14px " + theme.typography.fontFamily
            : "200 13px " + theme.typography.fontFamily,
        color: theme.brand.FIELDERS ? "6B8799" : Palette.Lysaght.DarkGrey,
        textShadow: "none",
    },
    startAdornment: {
        paddingLeft: "6px",
        paddingRight: "1px",
        font: theme.brand.FIELDERS
            ? "200 14px " + theme.typography.fontFamily
            : "200 13px " + theme.typography.fontFamily,
        color: theme.brand.FIELDERS ? "6B8799" : Palette.Lysaght.DarkGrey,
        textShadow: "none",
    },
    tooltip: {},
}));

const BSL_ToolTip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: Palette.Control.FieldersDarkBlue,
        color: "white",
        zIndex: 10000,
        whiteSpace: "pre-line",
    },
    arrow: {
        color: Palette.Control.FieldersDarkBlue,
        zIndex: 10000,
    },
}))(Tooltip);

export default function BSL_TextInput(props) {
    const classes = useStyles();
    const [loaded, setLoaded] = React.useState(false);
    const [displayValue, setDisplayValue] = React.useState(null);
    const inputRef = React.useRef(null);

    React.useEffect(() => {
        if (props.autoFocus) {
            if (props.selectAll) {
                inputRef.current.select();
            } else {
                inputRef.current.selectionStart = inputRef.current.value.length;
                inputRef.current.selectionEnd = inputRef.current.value.length;
            }
        }
    }, [loaded]);

    if (!loaded && props.autoFocus) setLoaded(true);

    let tooltip = "";

    if (props.min !== null && props.min !== undefined) {
        tooltip += (tooltip === "" ? "" : " ") + "Min:" + props.min;
    }

    if (props.max !== null && props.max !== undefined) {
        tooltip += (tooltip === "" ? "" : " ") + "Max:" + props.max;
    }

    if (props.tooltip) {
        tooltip += (tooltip === "" ? "" : " ") + props.tooltip ? props.tooltip : "";
    }

    if (props.label == "Role Code") {
        tooltip += "\n0: Dealer Standard\n10: Dealer Admin\n90: BBC Standard\n91: BBC State Admin\n99: BBC Super User";
    }

    if (props.disabled && props.disabledTooltip) {
        tooltip = props.disabledTooltip ? props.disabledTooltip : tooltip;
    }

    let inputPropsStyle = props?.inputPropsStyle ? props.inputPropsStyle : {};

    return (
        <BSL_ControlContainer {...props}>
            <BSL_ToolTip
                arrow
                enterDelay={props.tooltipDelay}
                disableFocusListener={tooltip === ""}
                disableHoverListener={props.disabled && props.disabledTooltip ? false : true}
                title={tooltip}
                placement="bottom-end"
            >
                <TextField
                    {...(props?.textFieldProps ? props?.textFieldProps : {})}
                    id={props.id ? props.id : Math.random().toString()}
                    disabled={props.disabled}
                    autoFocus={props.autoFocus}
                    inputRef={inputRef}
                    value={displayValue !== null ? displayValue : props.value}
                    placeholder={props.placeholder}
                    multiline={props.multiline}
                    rows={props.rows}
                    type={props.type}
                    inputProps={{
                        className:
                            classes.input +
                            (props.tight ? " " + classes.input_tight : "") +
                            (props?.extratight ? " " + classes.input_extra_tight : ""),
                        ...props.InputProps,
                        maxLength: props.maxLength,
                    }}
                    InputProps={{
                        classes: {
                            root: classes.textField,
                            disabled: classes.disabled,
                        },
                        style: inputPropsStyle,
                        startAdornment: props.startAdornment ? (
                            <div className={classes.startAdornment}>{props.startAdornment}</div>
                        ) : null,
                        endAdornment: props.endAdornment ? (
                            <div className={classes.endAdornment}>{props.endAdornment}</div>
                        ) : null,
                    }}
                    onKeyPress={(e) => {
                        if (e.key === "Enter" && !props.multiline) {
                            let out = { ...e };

                            if (!out.target) {
                                out.target = {};
                            }
                            if (out?.target?.value === undefined) {
                                out.target.value = displayValue;
                            }

                            if (props.allCaps) {
                                if (e?.target?.value) {
                                    out.target.value = e.target.value.toUpperCase();
                                }
                                if (out?.target?.value) {
                                    out.target.value = out.target.value.toUpperCase();
                                }
                            }
                            if (props.onEnter) props.onEnter(out);
                            else e.target.blur();
                        }
                        if (props.onKeyPress) props.onKeyPress(e);
                    }}
                    onKeyUp={(e) => {
                        if (e.key === "Escape") {
                            setDisplayValue(null);
                        }
                    }}
                    style={props.textFieldStyle ? props.textFieldStyle : { width: "95%" }}
                    onFocus={(e) => {
                        if (props?.onFocus) props.onFocus(e);
                    }}
                    onClick={props.onClick}
                    onBlur={(e) => {
                        let outValue = e.target.value;

                        if (
                            props.preValidate !== "alpha" &&
                            (props.preValidate === "numeric" || props.max !== undefined || props.min !== undefined)
                        ) {
                            outValue = toNumber(outValue);
                            if (props.allowZero && outValue === 0) {
                            } else if (props.max !== undefined && Number(outValue) > Number(props.max))
                                outValue = props.max;
                            else if (props.min !== undefined && Number(outValue) < Number(props.min))
                                outValue = props.min;
                        }

                        if (props.allCaps) outValue = outValue.toUpperCase();
                        if (props.onBlur) props.onBlur(outValue);
                        setDisplayValue(null);
                    }}
                    onChange={(e) => {
                        let value = e.target.value;

                        if (props.preValidate === "alpha") {
                            value = value.replace(/[^([a-zA-Z)]/gi, "");
                        }
                        if (props.preValidate === "alphaNumeric") {
                            value = value.replace(/[^\w\s]/gi, "");
                        }
                        if (props.preValidate === "name") {
                            value = value.replace(/[^\w\s/'/\-/(/)/^/®/™/©/</>]/gi, "");
                        }
                        if (props.preValidate === "numbersOnly") {
                            value = value.replace(/[^([0-9)]/gi, "");
                        }

                        if (
                            props.preValidate !== "alpha" &&
                            (props.preValidate === "numeric" || props.min || props.max)
                        ) {
                            //number only, including negative and decimal
                            let has_dot_on_end = value.endsWith(".");
                            if (value === "-") setDisplayValue(value);
                            else {
                                let dec = value?.split(".")?.[1];
                                if (dec && toNumber(dec) === 0) setDisplayValue(value);
                                else setDisplayValue(+toNumber(value) + (has_dot_on_end ? "." : ""));
                            }
                        } else {
                            if (props.max) {
                                if (value.length > props.max) value = value.substring(0, props.max);
                            }
                            setDisplayValue(value);
                        }
                        if (props.onChange) props.onChange(value);
                    }}
                />
            </BSL_ToolTip>
        </BSL_ControlContainer>
    );
}
